import { endpointsSpeckle } from "components/modules/UploadDialog/lib/actions/endpointsSpeckle";
import { fetcher } from "lib/actions/fetcher";
import { SpeckleApp } from "lib/types/speckle/SpeckleApp";
import useSWR from "swr";

export const useSpeckleApps = (workspaceId: number) => {
  const {
    data: apps,
    error,
    mutate,
  } = useSWR<SpeckleApp[]>(
    endpointsSpeckle.appRegistrations(workspaceId),
    fetcher,
  );

  return {
    apps: apps,
    isLoading: !apps && !error,
    hasError: !!error,
  };
};
